class SubscriptionTotalPrice implements ng.IComponentController {
    totalPrice: number;
}

angular.module('animatronApp.SubscriptionTotalPrice', [])
    .component('subscriptionTotalPrice', {
        bindings: {
            totalPrice: '<'
        },
        controller: SubscriptionTotalPrice,
        templateUrl: require('settings/subscription/subscription-total-price.html')
    });



// WEBPACK FOOTER //
// ./app/assets/javascripts/settings/subscription/SubscriptionTotalPrice.ts